var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_225",
    "data-name": "Group 225",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 63.544,
    height: 68.573,
    viewBox: "0 0 63.544 68.573",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 63.544,
    height: 68.573,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M20.3,55.716,8.225,59.626A11.89,11.89,0,0,0,.75,70.666",
    transform: "translate(-0.028 -2.094)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M44.962,55.716l12.076,3.91a11.89,11.89,0,0,1,7.475,11.04",
    transform: "translate(-1.689 -2.094)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M41.063,52.131l-8.051,4.6,3.45,5.75,8.051-6.9Z",
    transform: "translate(-1.24 -1.959)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M24.514,52.131l-3.45,3.45,8.051,6.9,3.449-5.75Z",
    transform: "translate(-0.791 -1.959)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M16.284,16.85a16.1,16.1,0,1,1,32.2,0",
    transform: "translate(-0.612 -0.028)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M51.467,17.479c2.858,0,4.025,2.06,4.025,4.6s-1.166,4.6-4.025,4.6H49.742v-9.2Z",
    transform: "translate(-1.869 -0.657)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M14.334,17.479c-2.858,0-4.025,2.06-4.025,4.6s1.166,4.6,4.025,4.6h1.725v-9.2Z",
    transform: "translate(-0.387 -0.657)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 2.3,
    cy: 2.3,
    r: 2.3,
    transform: "translate(31.772 39.822)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M49.293,29.428v6.9c0,3.764-2.122,6.9-5.751,6.9h-5.75",
    transform: "translate(-1.42 -1.106)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M30.623,7.919c0,7.528,7.692,12.65,14.95,12.65",
    transform: "translate(-1.151 -0.298)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M30.219,11.5c-7.259,1.451-10.35,5.033-10.35,13.5,0,7.2,0,16.4,10.35,18.7",
    transform: "translate(-0.747 -0.432)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M36.6,25.8s0-1.15,2.3-1.15a4.015,4.015,0,0,1,2.3,1.15h1.15",
    transform: "translate(-1.375 -0.926)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M29.2,25.8s0-1.15-2.3-1.15a4.015,4.015,0,0,0-2.3,1.15h-1.15",
    transform: "translate(-0.881 -0.926)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M36.328,35.358s-1.545,2.3-3.45,2.3-3.45-2.3-3.45-2.3a6.449,6.449,0,0,1,3.45-1.15A6.449,6.449,0,0,1,36.328,35.358Z",
    transform: "translate(-1.106 -1.285)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_73",
    "data-name": "Line 73",
    y2: 5.75,
    transform: "translate(24.872 42.122)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerSupport);
export default __webpack_public_path__ + "static/media/customer-support.5b4be688b26e9d2bc7b41d7660bd6b58.svg";
export { ForwardRef as ReactComponent };